document.addEventListener('DOMContentLoaded', () => {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    if (!isDesktop) return;

    const header = document.querySelector('.Header');
    if (!header) return;

    let activeSubmenu = null;

    document.querySelectorAll('.MegaNav__item').forEach((item, index) => {
        const submenu = item.querySelector('.MegaNav__subMenu');
        if (!submenu) return;

        const id = `mega-submenu-${index}`;
        item.dataset.megaSubmenu = id;
        submenu.dataset.megaSubmenu = id;

        header.appendChild(submenu);

        const trigger = item.querySelector('.MegaNav__itemLink') || item;

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (activeSubmenu === submenu) {
                submenu.classList.remove('open');
                activeSubmenu = null;
                return;
            }

            document
                .querySelectorAll('.MegaNav__subMenu.open')
                .forEach((el) => el.classList.remove('open'));

            submenu.classList.add('open');
            activeSubmenu = submenu;
        });

        submenu.addEventListener('click', (e) => e.stopPropagation());
    });

    document.addEventListener('click', () => {
        document
            .querySelectorAll('.MegaNav__subMenu.open')
            .forEach((el) => el.classList.remove('open'));
        activeSubmenu = null;
    });
});
